import gql from 'graphql-tag';

export const GET_SUMMARY_TOOLBAR_STATS_QUERY = gql`
  query GetSummaryToolbarStatsQuery($programId: Int!) {
    signedBriefs: getSignedAgreementsCountByProgramId(programId: $programId)
    shippedOrders: getShippedOrdersCountByProgramId(programId: $programId)
    approvedContent: getApprovedContentReviewsCountByProgramId(programId: $programId)
    totalRevenue: getAffiliateRevenueByProgramId(programId: $programId)
  }
`;
